// extracted by mini-css-extract-plugin
export default {"formFieldCheckboxWrapperParent":"DashboardGDPRModal_formFieldCheckboxWrapperParent__glktF","content":"DashboardGDPRModal_content__uX6YA"};